<template>
    <div class="step-2">
        <div class="checkout-personal-data-form">
            <div class="checkout-personal-data-form-title">
                {{ $t('personal_data.title') }}
            </div>
            <div class="checkout-personal-data-form-body">
                <b-form>
                    <div class="form-group mb-4">
                        <div class="custom-control custom-switch custom-switch-right">
                            <input type="checkbox" class="custom-control-input"
                                   v-model="form.is_company" id="form-field-deviant">
                            <label class="custom-control-label" for="form-field-deviant">
                                <span>{{ $t('personal_data.order_as_company') }}</span>
                            </label>
                        </div>
                    </div>
                    <div class="mb-5" v-if="form.is_company">
                        <div class="form-group">
                            <b-form-input v-model="form.company_name" type="text"
                                          :placeholder="`${$t('personal_data.company_name')} *`"
                                          :state="validation.company_name.valid"
                                          required></b-form-input>
                            <b-form-invalid-feedback :state="validation.company_name.valid">
                                {{ validation.company_name.message }}
                            </b-form-invalid-feedback>
                        </div>
                        <div class="form-group">
                            <b-form-input v-model="form.tax_id" type="text"
                                          :placeholder="$t('personal_data.tax_id')">
                            </b-form-input>
                        </div>
                    </div>
                    <div class="form-group">
                        <b-form-select id="form-field-salutation" v-model="form.salutation"
                                       :placeholder="`${$t('personal_data.greeting')} *`"
                                       :options="salutationOptions"></b-form-select>
                    </div>
                    <div class="form-group">
                        <b-form-input v-model="form.first_name" type="text"
                                      :placeholder="`${$t('personal_data.first_name')} *`"
                                      :state="validation.first_name.valid"
                                      required></b-form-input>
                        <b-form-invalid-feedback :state="validation.first_name.valid">
                            {{ validation.first_name.message }}
                        </b-form-invalid-feedback>
                    </div>
                    <div class="form-group">
                        <b-form-input v-model="form.last_name" type="text"
                                      :placeholder="`${$t('personal_data.second_name')} *`"
                                      :state="validation.last_name.valid"
                                      required></b-form-input>
                        <b-form-invalid-feedback :state="validation.last_name.valid">
                            {{ validation.last_name.message }}
                        </b-form-invalid-feedback>
                    </div>
                    <div class="form-group">
                        <b-form-input v-model="form.street" type="text"
                                      id="address" autocomplete="off"
                                      :placeholder="`${$t('personal_data.address')} *`"
                                      :state="validation.street.valid"
                                      required></b-form-input>
                        <b-form-invalid-feedback :state="validation.street.valid">
                            {{ validation.street.message }}
                        </b-form-invalid-feedback>
                    </div>
                    <div class="form-group">
                        <b-form-input v-model="form.zip" type="text"
                                      :placeholder="`${$t('personal_data.post_code')} *`"
                                      :state="validation.zip.valid"
                                      required></b-form-input>
                        <b-form-invalid-feedback :state="validation.zip.valid">
                            {{ validation.zip.message }}
                        </b-form-invalid-feedback>
                    </div>
                    <div class="form-group">
                        <b-form-input v-model="form.city" type="text"
                                      :placeholder="`${$t('personal_data.city')} *`"
                                      :state="validation.city.valid"
                                      required></b-form-input>
                        <b-form-invalid-feedback :state="validation.city.valid">
                            {{ validation.city.message }}
                        </b-form-invalid-feedback>
                    </div>
                    <div v-if="form.country_id" class="form-group">
                        <b-form-select v-model="form.country_id"
                                       value-field="id"
                                       text-field="name"
                                       :placeholder="`${$t('personal_data.country')} *`"
                                       :state="validation.country_id.valid"
                                       :options="orderCountryOptions"
                                       required></b-form-select>
                        <b-form-invalid-feedback :state="validation.country_id.valid">
                            {{ validation.country_id.message }}
                        </b-form-invalid-feedback>
                    </div>
                    <div class="form-group">
                        <b-form-input v-model="form.phone" type="text"
                                      :placeholder="`${$t('personal_data.mobile')} *`"
                                      :state="validation.phone.valid"
                                      required></b-form-input>
                        <b-form-invalid-feedback :state="validation.phone.valid">
                            {{ validation.phone.message }}
                        </b-form-invalid-feedback>
                    </div>
                    <div class="form-group" :class="{'mb-0': isMobile && authType === 'user' && !form.shipping_address}">
                        <a href="#" @click.prevent="form.shipping_address = !form.shipping_address"
                           class="btn btn-link btn-block btn-icon-left shipping-address-link">
                            <span class="material-icon" :class="form.shipping_address ? 'icon-remove' : 'icon-add'"></span>
                            {{ $t(form.shipping_address
                            ? 'personal_data.delete_shipping_address'
                            : 'personal_data.add_shipping_address') }}
                        </a>
                    </div>
                    <div v-show="form.shipping_address" :class="{'mb-5': !isMobile}">
                        <div class="form-group">
                            <b-form-input v-model="form.shipping_company_name" type="text"
                                          :placeholder="$t('personal_data.company_name')"></b-form-input>
                        </div>
                        <div class="form-group">
                            <b-form-select id="form-field-salutation" v-model="form.shipping_salutation"
                                           :placeholder="`${$t('personal_data.greeting')} *`"
                                           :options="salutationOptions"></b-form-select>
                        </div>
                        <div class="form-group">
                            <b-form-input v-model="form.shipping_first_name" type="text"
                                          :placeholder="`${$t('personal_data.first_name')} *`"
                                          :state="validation.shipping_first_name.valid"
                                          required></b-form-input>
                            <b-form-invalid-feedback :state="validation.shipping_first_name.valid">
                                {{ validation.shipping_first_name.message }}
                            </b-form-invalid-feedback>
                        </div>
                        <div class="form-group">
                            <b-form-input v-model="form.shipping_last_name" type="text"
                                          :placeholder="`${$t('personal_data.second_name')} *`"
                                          :state="validation.shipping_last_name.valid"
                                          required></b-form-input>
                            <b-form-invalid-feedback :state="validation.shipping_last_name.valid">
                                {{ validation.shipping_last_name.message }}
                            </b-form-invalid-feedback>
                        </div>
                        <div class="form-group">
                            <b-form-input v-model="form.shipping_address_street" type="text"
                                          id="diff-address" autocomplete="off"
                                          :placeholder="`${$t('personal_data.address')} *`"
                                          :state="validation.shipping_address_street.valid"
                                          required></b-form-input>
                            <b-form-invalid-feedback :state="validation.shipping_address_street.valid">
                                {{ validation.shipping_address_street.message }}
                            </b-form-invalid-feedback>
                        </div>
                        <div class="form-group">
                            <b-form-input v-model="form.shipping_address_zip" type="text"
                                          :placeholder="`${$t('personal_data.post_code')} *`"
                                          :state="validation.shipping_address_zip.valid"
                                          required></b-form-input>
                            <b-form-invalid-feedback :state="validation.shipping_address_zip.valid">
                                {{ validation.shipping_address_zip.message }}
                            </b-form-invalid-feedback>
                        </div>
                        <div class="form-group">
                            <b-form-input v-model="form.shipping_address_city" type="text"
                                          :placeholder="`${$t('personal_data.city')} *`"
                                          :state="validation.shipping_address_city.valid"
                                          required></b-form-input>
                            <b-form-invalid-feedback :state="validation.shipping_address_city.valid">
                                {{ validation.shipping_address_city.message }}
                            </b-form-invalid-feedback>
                        </div>
                        <div class="form-group" v-if="form.shipping_address_country">
                            <b-form-select v-model="form.shipping_address_country"
                                           value-field="id"
                                           text-field="name"
                                           :placeholder="`${$t('personal_data.country')} *`"
                                           :state="validation.shipping_address_country.valid"
                                           :options="orderCountryOptions"
                                           required></b-form-select>
                            <b-form-invalid-feedback :state="validation.shipping_address_country.valid">
                                {{ validation.shipping_address_country.message }}
                            </b-form-invalid-feedback>
                        </div>
                        <div class="form-group" :class="{'mb-0': isMobile && authType === 'user'}">
                            <b-form-input v-model="form.shipping_address_phone" type="text"
                                          :placeholder="$t('personal_data.mobile')"></b-form-input>
                        </div>
                    </div>
                    <div class="form-group" v-if="authType === 'guest' || authType === 'registration'">
                        <b-form-input v-model="form.email" type="email"
                                      :placeholder="`${$t('email')} *`"
                                      :state="validation.email.valid"
                                      required></b-form-input>
                        <b-form-invalid-feedback :state="validation.email.valid">
                            {{ validation.email.message }}
                        </b-form-invalid-feedback>
                    </div>
                    <div class="form-group" :class="{'mb-0': isMobile}" v-if="authType === 'guest'">
                        <b-form-input v-model="form.email_confirmation" type="email"
                                      :placeholder="`${$t('email_confirmation')} *`"
                                      :state="validation.email_confirmation.valid"
                                      required></b-form-input>
                        <b-form-invalid-feedback :state="validation.email_confirmation.valid">
                            {{ validation.email_confirmation.message }}
                        </b-form-invalid-feedback>
                    </div>
                    <template v-if="authType === 'registration'">
                        <div class="form-group">
                            <b-form-input v-model="form.password" type="password"
                                          :placeholder="`${$t('personal_data.password')} *`"
                                          :state="validation.password.valid"
                                          required></b-form-input>
                            <b-form-invalid-feedback :state="validation.password.valid">
                                {{ validation.password.message }}
                            </b-form-invalid-feedback>
                        </div>
                        <div class="form-group" :class="{'mb-0': isMobile}">
                            <b-form-input v-model="form.password_confirmation" type="password"
                                          :placeholder="`${$t('personal_data.confirm_password')} *`"
                                          :state="validation.password_confirmation.valid"
                                          required></b-form-input>
                            <b-form-invalid-feedback :state="validation.password_confirmation.valid">
                                {{ validation.password_confirmation.message }}
                            </b-form-invalid-feedback>
                        </div>
                    </template>
                </b-form>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .step-2 {
        display: flex;
        min-height: 100%;
        flex-grow: 1;
        flex-direction: column;
        justify-content: center;
    }
</style>

<script>
  import checkoutStep2 from 'src/mixins/checkoutStep2Component';

  export default {
    mixins: [checkoutStep2],
  };
</script>
